import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Header from "../Header";
import Principal from "../../pages/Principal";
import Separador from "../../pages/Separador";
import Controle from "../../pages/Controle";
import Estoque from "../../pages/Estoque";
import Cards from "../../pages/Cards";
import Perfil from "../../pages/Perfil";
import HorariosFuncionamento from "../../pages/HorariosFuncionamento";
import "./style.css";
import { ToastContainer } from "react-toastify";
import { Link, Route, Switch } from "react-router-dom";
import Areas from "../../pages/Areas";
import Entregador from "../../pages/Entregadores";
import { listarAreaCobertura } from "../../providers/AreaCoberturaProvider";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      <Box p={3}>{children}</Box>
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `wrapped-tab-${index}`,
    "aria-controls": `wrapped-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function TabsWrappedLabel(props) {
  const [status, setStatus] = React.useState("");
  const classes = useStyles();
  const [currentTab, setCurrentTab] = React.useState("/app/principal");

  const handleChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  React.useEffect(() => {
    if (props.location.pathname === "/") {
      props.history.push("/app/principal");
    }
  }, []);

  React.useEffect(() => {
    async function getUser() {
      const res = await listarAreaCobertura();
      setStatus(res);
    }
    getUser();
  }, []);

  return (
    <div className={classes.root}>
      <AppBar position="static" style={{ backgroundColor: "white" }}>
        <Header></Header>
        <Tabs
          variant="scrollable"
          scrollButtons="auto"
          value={currentTab}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          aria-label="wrapped label tabs example"
        >
          <Tab
            className="main-tab-items"
            value="/app/principal"
            label="Principal"
            wrapped
            component={Link}
            to="/app/principal"
            {...a11yProps(1)}
          />
          <Tab
            value="/app/separadores"
            label="Separadores"
            component={Link}
            to="/app/separadores"
            {...a11yProps(2)}
          />
          <Tab
            label="Entregadores"
            value="/app/entregadores"
            to="/app/entregadores"
            component={Link}
            {...a11yProps(3)}
          />
          <Tab
            value="/app/estoque"
            label="Estoque"
            component={Link}
            to="/app/estoque"
            {...a11yProps(4)}
          />
          <Tab
            value="/app/pagamento"
            label="Métodos de pagamento"
            component={Link}
            to="/app/pagamento"
            {...a11yProps(5)}
          />
          <Tab
            value="/app/dashboard"
            label="Dashboard de Controle"
            component={Link}
            to="/app/dashboard"
            {...a11yProps(6)}
          />
          <Tab
            value="/app/horarios"
            label="Horários de Funcionamento"
            component={Link}
            to="/app/horarios"
            {...a11yProps(7)}
          />
          {status.entrega_propria && (
            <Tab
              value="/app/areas"
              label="Área de Cobertura"
              component={Link}
              to="/app/areas"
              {...a11yProps(9)}
            />
          )}
          <Tab
            value="/app/perfil"
            label="Perfil"
            component={Link}
            to="/app/perfil"
            {...a11yProps(8)}
          />
        </Tabs>

        <div id="loader" className="loader" style={{ height: 10 }}>
          <div className="loaderBar"></div>
        </div>

        <Switch>
          <Route
            path="/app/principal"
            render={() => {
              return (
                <div className="container-div">
                  <Principal />
                </div>
              );
            }}
          />
          <Route
            path="/app/separadores"
            render={() => {
              return (
                <div className="container-div">
                  <Separador></Separador>
                </div>
              );
            }}
          />
          <Route
            path="/app/entregadores"
            render={() => {
              return (
                <div className="container-div">
                  <Entregador></Entregador>
                </div>
              );
            }}
          />
          <Route
            path="/app/estoque"
            render={() => {
              return (
                <div className="container-div">
                  <Estoque></Estoque>
                </div>
              );
            }}
          />
          <Route
            path="/app/pagamento"
            render={() => {
              return (
                <div className="container-div">
                  <Cards />
                </div>
              );
            }}
          />
          <Route
            path="/app/dashboard"
            render={() => {
              return (
                <div className="container-div">
                  <Controle />
                </div>
              );
            }}
          />
          <Route
            path="/app/horarios"
            render={() => {
              return (
                <div className="container-div">
                  <HorariosFuncionamento />
                </div>
              );
            }}
          />
          <Route
            path="/app/perfil"
            render={() => {
              return (
                <div className="container-div">
                  <Perfil />
                </div>
              );
            }}
          />
          {status.entrega_propria && (
            <Route
              path="/app/areas"
              render={() => {
                return (
                  <div className="container-div">
                    <Areas />
                  </div>
                );
              }}
            />
          )}
        </Switch>
      </AppBar>

      <ToastContainer></ToastContainer>
    </div>
  );
}
